import { type DoctorServiceExpanded } from "@hermes/api";

export const isChildService = ({ age_to }: DoctorServiceExpanded) =>
  age_to && age_to <= 216;

export const findChildService = (
  allDoctorServices: DoctorServiceExpanded[],
  currentServiceId?: number,
): DoctorServiceExpanded | undefined => {
  return allDoctorServices.find(
    ({ service }) =>
      service.is_for_children === true &&
      service.adult_service === currentServiceId,
  );
};

export const isAllServiceHasChild = (service?: DoctorServiceExpanded) => {
  return !!(service && service.age_to && service.age_to <= 216);
};

export const getAgeRangeValues = (
  age_from: number | null,
  age_to: number | null,
) => {
  const from = convertAge(age_from);
  const to = convertAge(age_to);
  return {
    age_from: from,
    age_to: to,
    age_from_unit: age_from && age_from > 12 ? "y" : "m",
    age_to_unit: age_to && age_to > 12 ? "y" : "m",
  };
};

const convertAge = (value: number | null): number =>
  Math.floor((value ?? 0) > 12 ? (value ?? 0) / 12 : (value ?? 0));
